import { useUserProfileContext } from "@context/user_profile";
import { Navigate, Outlet } from "react-router";
import { LoaderIcon } from "lucide-react";
import { getPostAuthLandingPath } from "@util/auth-redirect";

export default function GuestRoute() {
    const [isLoadingUserProfile, userInfo] = useUserProfileContext();
    if (isLoadingUserProfile) return (
        <div className="fixed inset-0 flex items-center justify-center bg-white">
            <LoaderIcon className="h-8 w-8 animate-spin text-gray-400" />
        </div>
    );

    if (userInfo) {
        // The same landing as after login: demo-practice job_seekers on
        // /browse, Oura users and admins in Oura, everyone else on /dashboard.
        const destination = getPostAuthLandingPath(userInfo.role);
        return (
            <Navigate to={destination} />
        )
    }

    return <Outlet />
}